import CourtsApiGateway from "../../interfaces/gateways/courts-api.gateway";
import MapRepository from "../../interfaces/gateways/map.repository";
import CourtEntity from "../../../courts/entities/court.entity";
import {ICourtsAPIModel} from "../../../common/api/api-models";

export default class LoadCourtsUseCase {
  constructor (
    private readonly courtsGateway: CourtsApiGateway,
    private readonly mapRepository: MapRepository,
  ) {
  }

  async execute (): Promise<void> {
    try {
      const newCourts: CourtEntity[] = []
      const location = this.mapRepository.getLocation()
      const radius = 300
      const search = this.mapRepository.getSearchTerm()
      let allCourts: ICourtsAPIModel[] = []
      allCourts = await this.courtsGateway.getNearbyCourts(location.lat, location.lng, search, radius)
      allCourts.forEach((court) => {
        const ct = new CourtEntity()
        ct.fromAPIModel(court)
        newCourts.push(ct)
      })
      this.mapRepository.setCourts(newCourts)
    } catch (e) {
      console.log(e)
    }
  }
}
